"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWaterQualityStatus = void 0;
const types_1 = require("../../types");
const getWaterQualityStatus = (value, labelProvider) => {
    // Higher sensor value means lower water quality.
    // We want percentage to reflect quality: 100% is best (low sensor value), 0% is worst (high sensor value).
    // We'll use WaterQualityThresholds.poor (3000 µS/cm) as the point where quality effectively drops to 0%.
    const qualityScaleMax = types_1.WaterQualityThreshold.poor;
    const percentage = Math.round(Math.max(0, (1 - value / qualityScaleMax) * 100));
    const tds = Math.round(value * 0.6);
    if (value <= types_1.WaterQualityThreshold.excellent) {
        return {
            value,
            percentage,
            tds,
            threshold: types_1.WaterQualityThreshold.excellent,
            color: types_1.WaterQualityColor.Blue,
            label: labelProvider(types_1.WaterQualityThreshold.excellent),
        };
    }
    else if (value <= types_1.WaterQualityThreshold.good) {
        return {
            value,
            percentage,
            tds,
            threshold: types_1.WaterQualityThreshold.good,
            color: types_1.WaterQualityColor.Blue,
            label: labelProvider(types_1.WaterQualityThreshold.good),
        };
    }
    else if (value <= types_1.WaterQualityThreshold.fair) {
        return {
            value,
            percentage,
            tds,
            threshold: types_1.WaterQualityThreshold.fair,
            color: types_1.WaterQualityColor.Yellow,
            label: labelProvider(types_1.WaterQualityThreshold.fair),
        };
    }
    else if (value <= types_1.WaterQualityThreshold.poor) {
        return {
            value,
            percentage,
            tds,
            threshold: types_1.WaterQualityThreshold.poor,
            color: types_1.WaterQualityColor.Red,
            label: labelProvider(types_1.WaterQualityThreshold.poor),
        };
    }
    else {
        return {
            value,
            percentage,
            tds,
            threshold: types_1.WaterQualityThreshold.veryPoor,
            color: types_1.WaterQualityColor.Red,
            label: labelProvider(types_1.WaterQualityThreshold.veryPoor),
        };
    }
};
exports.getWaterQualityStatus = getWaterQualityStatus;
